<div class="routing-rule-dialog-advanced routing-rule-settings">
    <div class="conditions-column">
        <div class="row-1">
            <ac-line-separator separatorId="rule-quality-based-routing" title="Quality Based Routing"></ac-line-separator>

            <ac-input-container label="Include paths with the following quality" class="dialog-advanced-input">
                <ac-select [(acModel)]="rule.quality"
                           [items]="qualityOptions"
                           [allowClear]="true"
                           [bindLabel]="'label'"
                           [bindValue]="'value'">
                </ac-select>
            </ac-input-container>
        </div>

        <div class="row-2">
            <ac-line-separator separatorId="rule-time-based-routing" title="Time Based Routing"></ac-line-separator>

            <ac-input-container label="Use time conditions" class="dialog-advanced-input">
                <ac-select class="single-row"
                           [(acModel)]="rule.tbrConditionsIds"
                           [items]="timeConditionsOptions"
                           [multiple]="true"
                           [allowClear]="true"
                           [bindLabel]="'name'"
                           [bindValue]="'id'">
                </ac-select>
            </ac-input-container>
        </div>

        <div class="row-3">
            <ac-line-separator separatorId="security-based-routing" title="Security Based Routing"></ac-line-separator>
            <div class="rule-secure-logix-content">
                <mat-checkbox name="enableDate" color="primary" (change)="secureLogixChanged()"
                              [(ngModel)]="rule.isSecureLogixEnabled">Security call score</mat-checkbox>
                <ng5-slider [(value)]="rule.minSecureLogix" [(highValue)]="rule.maxSecureLogix" [options]="secureLogixOptions"></ng5-slider>

                <mat-slide-toggle name="enableSecureLogixActionDirective" color="primary" (change)="secureLogixChanged()"
                                  [(ngModel)]="rule.isActionDirective">Action Directive</mat-slide-toggle>
              <div class="action-directive-row">
                  <mat-checkbox name="enableSecureLogixActionDirective" color="primary" (change)="secureLogixChanged()"
                                [disabled]="!rule.isActionDirective"
                                [(ngModel)]="rule.isActionDirectiveAllow">Allow</mat-checkbox>
                  <mat-checkbox name="enableSecureLogixActionDirective" color="primary" (change)="secureLogixChanged()"
                                [disabled]="!rule.isActionDirective"
                                [(ngModel)]="rule.isActionDirectiveBlock">Block</mat-checkbox>
                  <mat-checkbox name="enableSecureLogixActionDirective" color="primary" (change)="secureLogixChanged()"
                                [disabled]="!rule.isActionDirective"
                                [(ngModel)]="rule.isActionDirectiveRedirect">Redirect</mat-checkbox>
              </div>
                <mat-error *ngIf="rule.isActionDirective && !rule.isActionDirectiveAllow && !rule.isActionDirectiveBlock && !rule.isActionDirectiveRedirect">
                    At least one of the actions must be enabled
                </mat-error>
            </div>
        </div>

        <div class="row-4">
            <ac-line-separator separatorId="rule-prioritize-call" title="Prioritize call"></ac-line-separator>
            <mat-checkbox name="enableDate" color="primary" class="prioritize-call"
                          [(ngModel)]="rule.isEmergency">Prioritize call when this rule is selected</mat-checkbox>
        </div>

        <div class="row-5">
            <ac-line-separator separatorId="rule-prioritize-call" title="Registered users"></ac-line-separator>

            <mat-checkbox name="enableDate" color="primary" class="registered-users"
                          [(ngModel)]="rule.isRegisteredUsers">Destination is a registered user in ARM</mat-checkbox>
        </div>

        <div class="row-6">
            <ac-line-separator separatorId="sip-condition-group" title="SIP condition group"></ac-line-separator>

            <ac-input-container label="SIP condition group" class="dialog-advanced-input">
                <ac-select class="single-row"
                           [(acModel)]="rule.sipConditionGroupId"
                           [items]="sipConditionGroups"
                           [allowClear]="true"
                           [bindLabel]="'name'"
                           [bindValue]="'id'">
                </ac-select>
            </ac-input-container>
        </div>
    </div>

    <div class="conditions-column">
        <div class="row-1">
            <ac-line-separator separatorId="rule-call-trigger" title="Call trigger"></ac-line-separator>

            <div class="call-trigger">
                <mat-checkbox color="primary" [(ngModel)]="rule.isTrigger3xx">3xx</mat-checkbox>
                <mat-checkbox color="primary" [(ngModel)]="rule.isTriggerRefer">Refer</mat-checkbox>
                <mat-checkbox color="primary" [(ngModel)]="rule.isTriggerInitialOnly">Initial</mat-checkbox>
                <mat-checkbox color="primary" [(ngModel)]="rule.isTriggerBrokenConnection">Broken connection</mat-checkbox>
                <mat-checkbox color="primary" [(ngModel)]="rule.isTriggerFaxRerouting">Fax rerouting</mat-checkbox>
            </div>
          <mat-error *ngIf="!rule.isTrigger3xx && !rule.isTriggerRefer && !rule.isTriggerInitialOnly && !rule.isTriggerBrokenConnection && !rule.isTriggerFaxRerouting">
            At least one of the call triggers must be enabled
          </mat-error>
        </div>

        <div class="row-2">
            <ac-line-separator separatorId="rule-rule-match" title="Rule match"></ac-line-separator>

            <mat-checkbox color="primary" [(ngModel)]="rule.eventOnMatch">Send notification upon match</mat-checkbox>
        </div>

      <div class="row-3">
        <ac-line-separator separatorId="rule-prevent-loopback" title="Prevent source loopback"></ac-line-separator>

        <div class="call-trigger">
          <mat-checkbox color="primary" [(ngModel)]="rule.isPreventSourceLoopbackPcon">Peer Connection</mat-checkbox>
          <mat-checkbox color="primary" [(ngModel)]="rule.isPreventSourceLoopbackVoipPeer">VoipPeer</mat-checkbox>
          <mat-checkbox color="primary" [(ngModel)]="rule.isPreventSourceLoopbackNode">Node</mat-checkbox>
        </div>
      </div>

        <div class="row-4">
            <ac-line-separator separatorId="rule-prioritize-call" title="Request type"></ac-line-separator>

            <ac-input-container label="Request type" class="dialog-advanced-input">
                <ac-select [(acModel)]="rule.requestType"
                           [items]="requestTypeOptions"
                           [searchable]="false"
                           [bindLabel]="'label'"
                           [bindValue]="'value'">
                </ac-select>
            </ac-input-container>

            <ac-input-container label="Privacy policy" class="dialog-advanced-input">
                <ac-select [(acModel)]="rule.privacy"
                           [items]="privacyOptions"
                           [searchable]="false"
                           [bindLabel]="'label'"
                           [bindValue]="'value'">
                </ac-select>
            </ac-input-container>
        </div>

        <div class="row-5">
            <ac-line-separator separatorId="rule-sip-headers" title="Sip headers"></ac-line-separator>

            <div class="advanced-conditions-container">
                <div class="advanced-conditions-list">
                    <div *ngFor="let item of rule.sipHeaders; let index = index;" class="advanced-conditions-item">
                      <div class="advanced-conditions-item-name-values">
                        <mat-form-field class="advanced-conditions-item-name">
                            <mat-label>Name</mat-label>
                            <input matInput [(ngModel)]="item.name" name="name">
                        </mat-form-field>

                        <ac-input-container class="advanced-conditions-item-values" label="Values:">
                            <ac-select class="value-in-test-list"
                                       [(acModel)]="item.value"
                                       [addCustomTags]="true"
                                       [bindLabel]="null"
                                       [bindValue]="null"
                                       [multiple]="true"
                                       [allowClear]="true"
                                       [width]="'320'">
                            </ac-select>
                        </ac-input-container>
                      </div>
                        <i class="fa fa-times remove-item" (click)="removeSipHeader(index)"></i>
                    </div>
                </div>
                <div class="action-buttons">
                    <button (click)="addSipHeader()" [disabled]="rule.sipHeaders.length === 5" mat-icon-button matTooltip="Add">
                        <mat-icon [svgIcon]="'add'" class="icon-display"></mat-icon>
                    </button>
                </div>
            </div>
          <mat-error *ngIf="!isSipHeaderValid">
            You must fill name and value
          </mat-error>
        </div>

        <div class="row-6">
            <ac-line-separator separatorId="rule-sip-headers" title="Tags"></ac-line-separator>

            <div class="advanced-conditions-container">
                <div class="advanced-conditions-list">
                    <div *ngFor="let item of rule.tags; let index = index;" class="advanced-conditions-item"
                         [ngClass]="{'odd': index % 2 === 0}">

                      <div class="advanced-conditions-item-name-values">

                        <ac-input-container label="Tag">
                            <ac-select [(acModel)]="item.tag"
                                       (change)="updateTags()"
                                       [items]="tagOptions"
                                       [allowClear]="false"
                                       [bindLabel]="'label'"
                                       [bindValue]="'value'"
                                       [width]="'159'">
                            </ac-select>
                        </ac-input-container>

                        <ac-input-container class="advanced-conditions-item-values" label="Values">
                            <ac-select class="single-row value-in-test-list"
                                       [(acModel)]="item.value"
                                       [addCustomTags]="true"
                                       [bindLabel]="null"
                                       [bindValue]="null"
                                       [multiple]="true"
                                       [allowClear]="true"
                                       [width]="'320'">>
                            </ac-select>
                        </ac-input-container>
                      </div>
                        <i class="fa fa-times remove-item" (click)="removeTag(index)"></i>
                    </div>
                </div>
                <div class="action-buttons">
                    <button (click)="addTag()" [disabled]="rule.tags.length === 3" mat-icon-button matTooltip="Add">
                        <mat-icon [svgIcon]="'add'" class="icon-display"></mat-icon>
                    </button>
                </div>
            </div>
          <mat-error *ngIf="!isTagValid">
            You must fill name and value
          </mat-error>
        </div>
    </div>
</div>
